module.exports = __webpack_public_path__ + "img/BlueSky.d6b539f3.svg";